export function setEanLocalInfo(data) {
  return {
    type: 'SET_EAN_INFO',
    data,
  };
}